import { render, staticRenderFns } from "./StructDataView.vue?vue&type=template&id=1b38e180&scoped=true"
import script from "./StructDataView.vue?vue&type=script&lang=js"
export * from "./StructDataView.vue?vue&type=script&lang=js"
import style0 from "./StructDataView.vue?vue&type=style&index=0&id=1b38e180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b38e180",
  null
  
)

export default component.exports